// extracted by mini-css-extract-plugin
export default {"signup":"Signup_signup__ysXkW"};